import { reportServiceBaseUrl,templateBaseurl2 } from "services/http";

export const reportServiceEndpoints={
    bulkNotification:{
        getAllReports:`${reportServiceBaseUrl}/bulk-notifications/userId`,
        getChannelReports:`${reportServiceBaseUrl}/bulk-notifications`,
        cancelScheduledNotification: `${templateBaseurl2}/scheduled-notifications/cancel`
    },
    getAllReportCategory:`${reportServiceBaseUrl}/getAllReportCategory`,
    reportCategory:`${reportServiceBaseUrl}/reportCategory`

}